import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { FeatureService } from '../services/feature.service';

@Directive({
  selector: '[libFeatureFlag]',
  standalone: true,
})
export class FeatureFlagDirective implements OnInit {
  readonly templateRef = inject(TemplateRef<unknown>);
  readonly viewContainerRef = inject(ViewContainerRef);
  readonly featureService = inject(FeatureService);

  @Input({ required: true })
  libFeatureFlag: string;

  @Input() libFeatureFlagElse: TemplateRef<unknown>;

  ngOnInit() {
    this.viewContainerRef.clear();
    if (this.featureService.getFeatureActive(this.libFeatureFlag)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else if (this.libFeatureFlagElse) {
      this.viewContainerRef.createEmbeddedView(this.libFeatureFlagElse);
    }
  }
}
